import { RouterProvider } from 'react-router-dom';
import { AppBrowserRouter } from '../../app/app-router';
import { WidgetAsyncFallback } from '../widget/WidgetAsyncFallback';
import React from 'react';

const AppRouterImpl = () => {
    return <RouterProvider router={AppBrowserRouter} fallbackElement={<WidgetAsyncFallback />} />;
};
export const AppRouter = React.memo(AppRouterImpl, () => true);
